import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('receipts', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('receipt?rt_id=' + data.rt_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('receipt', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('receipt', data, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('receipt/status', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('receipt', { data: data }, options))
  },

  async getLatestCode (data) {
    return store.dispatch('checkResponseApi', await Api().get('receipt/latest_code'))
  },
}



// WEBPACK FOOTER //
// ./src/api/ReceiptService.js